import React from 'react'

const CustomGenderHeader = ({text}) => {
  return (
    <h6 className="mb-4 text-left items-gender">{text}</h6>
  )
}

export default CustomGenderHeader